import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/** "By {teacher}" line reused across course cards (Store, sponsored rows,
 * module header): a small circular avatar (photo, or initials fallback)
 * next to each teacher's name, linking to their public profile. Sized to
 * sit inline without changing the card's layout. */
export default function TeacherByline({ teachers, className = '', dark = false }) {
  const { t } = useTranslation();
  if (!teachers || teachers.length === 0) return null;

  const textTone = dark ? 'text-primary-100' : 'text-gray-500';
  const linkTone = dark ? 'text-white hover:text-primary-100 underline' : 'text-primary-600 hover:text-primary-700';

  return (
    <div className={`flex items-center flex-wrap gap-1 text-xs ${textTone} ${className}`}>
      <span>{t('By')}</span>
      {teachers.map((teacher, idx) => {
        const initial = (teacher.first_name || '?')[0] || '';
        return (
          <span key={teacher.id} className="flex items-center gap-1">
            {idx > 0 && <span>,</span>}
            <Link
              to={`/teachers/${teacher.id}`}
              onClick={(e) => e.stopPropagation()}
              className={`inline-flex items-center gap-1 font-medium ${linkTone}`}
            >
              <span className="w-4 h-4 rounded-full overflow-hidden bg-gray-200 flex items-center justify-center shrink-0">
                {teacher.profile_picture ? (
                  <img src={teacher.profile_picture} alt="" className="w-full h-full object-cover" />
                ) : (
                  <span className="text-[8px] font-bold text-gray-500 leading-none">{initial.toUpperCase()}</span>
                )}
              </span>
              {teacher.first_name} {teacher.last_name}
            </Link>
          </span>
        );
      })}
    </div>
  );
}
